import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
// import { Dropdown, Option } from "./Dropdown";
import { Form, Button } from "react-bootstrap";
// import Form from "react-bootstrap/Form";
//import { createDevice } from "../services/createDevice";
import Editable from "react-bootstrap-editable";
import axios from "axios";
import { environment } from "../../environment";
import { RadioGroup, Radio } from "@adobe/react-spectrum";
import { LinkContainer } from "react-router-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Select from "react-select";
import { Country, State, City } from "country-state-city";
import {
  CountryDropdown,
  RegionDropdown,
  CountryRegionData,
} from "react-country-region-selector";
import NavbarNew from "../Components/NavbarNew";

const MySwal = withReactContent(Swal);

const AddLeads = ({ history }) => {
  const [users, setUsers] = useState([]);
  const [dap_name, setName] = useState("");
  const [dap_lastname, setLastName] = useState("");
  const [dap_organization, setOrganization] = useState("");
  const [dap_industry, setIndustry] = useState("");
  const [dap_source, setSource] = useState("");
  const [dap_designation, setDesignation] = useState("");
  const [dap_awareness, setAwareness] = useState("");
  const [dap_interest, setInterest] = useState("");
  const [dap_probability, setProbability] = useState("");
  const [dap_role, setRole] = useState("");
  const [dap_email, setEmail] = useState("");
  const [dap_phone, setPhone] = useState("");
  const [dap_dob, setDOB] = useState("");
  const [dap_billable, setBillable] = useState(false);
  const [dap_package, setPackage] = useState({});
  const [visible, setVisible] = useState(false);
  const [dap_price, setPrice] = useState("");
  const [dap_address, setAddress] = useState("");
  const [dap_city, setDapCity] = useState([]);
  const [dap_countries, setDapCountries] = useState("");
  const [dap_states, setDapState] = useState([]);
  const [country, setCountry] = useState("");
  const [zip, setZip] = useState("");
  const [region, setRegion] = useState("");
  const [loading, setLoading] = useState(false);
  const [countrycode, setCountryCode] = useState("");
  const [postcountry, setPostCountry] = useState("");
  const [poststate, setPostState] = useState("");
  const [postcity, setPostCity] = useState("");
  const [emailErrors, setEmailErrors] = useState({});
  const [nameErrors, setNameErrors] = useState({});
  const [lastnameErrors, setLastNameErrors] = useState({});
  const [phoneErrors, setPhoneErrors] = useState({});
  const [organizationErrors, setOrganizationErrors] = useState({});
  const [designationErrors, setDesignationErrors] = useState({});
  const [sourceErrors, setSourceErrors] = useState({});
  const [industryErrors, setIndustryErrors] = useState({});
  const [awarenessErrors, setAwarenessErrors] = useState({});
  const [interestErrors, setInterestErrors] = useState({});
  const [countryErrors, setCountryErrors] = useState({});
  const [stateErrors, setstateErrors] = useState({});
  const [cityErrors, setCityErrors] = useState({});
  const [zipErrors, setZipErrors] = useState({});
  const [probabilityErrors, setProbabilityErrors] = useState({});
  const [addressErrors, setAddressErrors] = useState({});
  const [goBackLink, setGoBackLink] = useState("");
  const [packageError, setPackageError] = useState("");
  let roles = [];
  roles = [
    {
      roleType: "Trial",
      roleId: 1,
    },
    {
      roleType: "Diamond", //"Basic"
      roleId: 2,
    },
    {
      roleType: "Gold",  //"Advance",
      roleId: 3,
    },
    {
      roleType: "Silver",  //"Corporate",
      roleId: 4,
    },
  ];
  let roles1 = [];
  roles1 = [
    {
      roleType: "Email",
      roleId: 1,
    },
    {
      roleType: "Website",
      roleId: 2,
    },
    {
      roleType: "Social Media",
      roleId: 3,
    },
    {
      roleType: "Campaign",
      roleId: 4,
    },
    {
      roleType: "TradeShow",
      roleId: 5,
    },
    {
      roleType: "Events",
      roleId: 6,
    },
    {
      roleType: "Others",
      roleId: 7,
    },
  ];
  let roles2 = [];
  roles2 = [
    {
      roleType: "Corporate",
      roleId: 1,
    },
    {
      roleType: "Education",
      roleId: 2,
    },
    {
      roleType: "Healthcare",
      roleId: 3,
    },
    {
      roleType: "Hospitality",
      roleId: 4,
    },
    {
      roleType: "Manufacturing",
      roleId: 5,
    },
    {
      roleType: "Others",
      roleId: 6,
    },
  ];
  let roles3 = [];
  roles3 = [
    {
      roleType: "1",
      roleId: 1,
    },
    {
      roleType: "2",
      roleId: 2,
    },
    {
      roleType: "3",
      roleId: 3,
    },
    {
      roleType: "4",
      roleId: 4,
    },
    {
      roleType: "5",
      roleId: 5,
    },
  ];
  let roles4 = [];
  roles4 = [
    {
      roleType: "1",
      roleId: 1,
    },
    {
      roleType: "2",
      roleId: 2,
    },
    {
      roleType: "3",
      roleId: 3,
    },
    {
      roleType: "4",
      roleId: 4,
    },
    {
      roleType: "5",
      roleId: 5,
    },
  ];

  let countries = [];
  let states = [];
  countries = Country.getAllCountries();
  states = State.getAllStates();
  const selectCountry = (e) => {
    setDapCountries(Country.getAllCountries());
    setDapState(State.getStatesOfCountry(e.id));
    setCountryCode(e.id);
    setPostCountry(e.label);
  };

  const selectRegion = (e) => {
    setDapCity(City.getCitiesOfState(countrycode, e.id));
    setPostState(e.label);
  };
  const selectCity = (e) => {
    setPostCity(e.label);
  };
  useEffect(() => {
    if (localStorage.getItem("isLeadExecutive")) {
      setGoBackLink("/get-leads");
    } else {
      setGoBackLink("/addLeads");
    }

    console.log("ananay");
    // axios
    //   .get(
    //     environment.dap_url +
    //       "crm_api/getLeadByLeadExecutiveId?lead_executive_id=" +
    //       JSON.parse(localStorage.getItem("executivedetails"))._id
    //   )
    //   .then((res) => {
    //     const dap_users = res.data;
    //     console.log(res);
    //     setUsers(res.data);
    //     console.log(res.data);
    //   })
    //   .catch(function (error) {
    //     MySwal.fire({
    //       title: <p>{error.message}</p>,
    //       type: "error",
    //     });
    //   });
    var output = document.getElementById("percent");
    output.innerHTML = "50%";
  }, []);

  // console.log(Country.getAllCountries());
  // console.log(Country.getAllCountries());
  // console.log(State.getAllStates());

  const checkemail = (e) => {
    setEmail(e.target.value);
    console.log(e.target.value);
    axios
      .post(environment.dap_url + "crm_api/checkDuplicateMail", {
        email: e.target.value,
      })
      .then((response) => {
        const data = response.data;
        console.log(data);
        console.log(data.status);
        if (data.status === true) {
          // Email already exists
          setEmailErrors({ duplicateEmail: "* Email address already exists" });

          // isValid = false;
        } else if (data.status === false) {
          setEmailErrors({});
        }
      })
      .catch((error) => {
        console.log("Error checking duplicate email:", error);
      });
  };

  //  const checkorganization = (e) =>{
  //   setOrganization(e.target.value);
  //   console.log(e.target.value);
  //   axios.post(environment.dap_url +"crm_api/checkDuplicateorganization", {
  //         organization:e.target.value})
  //         .then((response) => {
  //           const data = response.data;
  //           console.log(data);
  //           console.log(data.status);
  //           if (data.status==true) {
  //             // Email already exists
  //             setOrganizationErrors({duplicateOrganization : "* Organization already exists"});

  //            // isValid = false;
  //           }
  //           })
  //       .catch((error) => {
  //         console.log("Error checking duplicate organization:", error);
  //       });

  //    }

  const formValidation = () => {
    const emailErrors = {};
    const nameErrors = {};
    const phoneErrors = {};
    const designationErrors = {};
    const organizationErrors = {};
    const lastnameErrors = {};
    const sourceErrors = {};
    const industryErrors = {};
    const awarenessErrors = {};
    const interestErrors = {};
    const countryErrors = {};
    const stateErrors = {};
    const cityErrors = {};
    const zipErrors = {};
    const probabilityErrors = {};
    const addressErrors = {};
    const packageError = {};
    let isValid = true;

    if (!dap_email) {
      emailErrors.noEmail = "* Email Id required";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(dap_email)) {
      emailErrors.invalidEmail = "* Email address is invalid";
      isValid = false;
    } else if (dap_email != "") {
      let mailCheck = new Promise(async (resolve, reject) => {
        await axios
          .post(environment.dap_url + "crm_api/checkDuplicateMail", {
            email: dap_email,
          })
          .then((response) => {
            const data = response.data;
            console.log(data);
            console.log(data.status);
            resolve(data.status);
          })
          .catch((error) => {
            console.log("Error checking duplicate email:", error);
            reject(error);
          });
      });
      mailCheck
        .then((result) => {
          console.log(result);
          if (result) {
            isValid = true;
            emailErrors = {};
          } else {
            isValid = false;
            emailErrors.duplicateEmail = "* Email address already exists";
          }
        })
        .catch((err) => {
          isValid = false;
        });
      console.log("mail", mailCheck);
      // if(mailCheck.){
      //   emailErrors.duplicateEmail = "* Email address already exists";
      //   isValid = false;
      // }else{
      //   emailErrors = {}
      //   setEmailErrors({})
      // }
    }

    //   else{
    //     axios.post(environment.dap_url +"crm_api/checkDuplicateMail", {
    //     email:dap_email})
    //     .then((response) => {
    //       const data = response.data;
    //       console.log(data);
    //       console.log(data.status);
    //       if (data.status==true) {
    //         // Email already exists
    //         emailErrors.duplicateEmail = "* Email address already exists";
    //         isValid = false;
    //       }
    //       })
    //   .catch((error) => {
    //     console.log("Error checking duplicate email:", error);
    //   });
    // }

    //  else if (dap_email == e.target.value) {
    //   emailErrors.duplicateEmail = "* Email address is already exist";
    //   isValid = false;
    // }
    if (!dap_name) {
      nameErrors.noName = "*First Name is required";
      isValid = false;
    } else if (dap_name.trim().length < 2) {
      nameErrors.shortName = "* First Name is too short";
      isValid = false;
    }
    if (!dap_lastname) {
      lastnameErrors.noName = "*Last Name is required";
      isValid = false;
    } else if (dap_name.trim().length < 2) {
      lastnameErrors.shortName = "* Last Name is too short";
      isValid = false;
    }
    if (!dap_organization) {
      organizationErrors.noOrganization = "* Organization is required";
      isValid = false;
    } else if (dap_organization.trim().length < 1) {
      organizationErrors.shortOrganization = "* Organization is too short";
      isValid = false;
    }
    // else{
    //   organizationErrors.duplicateOrganization="* organization already exists"
    //   isValid = false;
    // }

    if (!dap_designation) {
      designationErrors.noDesignation = "* Designation is required";
      isValid = false;
    } else if (dap_designation.trim().length < 1) {
      designationErrors.shortDesignation = "* Designation is too short";
      isValid = false;
    }
    if (!dap_source.id) {
      sourceErrors.noSource = "* Source Field is required";
      isValid = false;
    } else if (dap_source.id.trim().length < 2) {
      sourceErrors.shortSource = "* Source is too short";
      isValid = false;
    }
    if (!dap_industry.id) {
      industryErrors.noIndustry = "* Industry Field is required";
      isValid = false;
    } else if (dap_industry.id.trim().length < 1) {
      industryErrors.shortIndustry = "* Industry is too short";
      isValid = false;
    }
    if (!dap_awareness.id) {
      awarenessErrors.noAwareness = "* Awareness Field is required";
      isValid = false;
    } else if (dap_awareness.id.trim().length < 0) {
      awarenessErrors.shortAwareness = "* Awareness is too short";
      isValid = false;
    }
    if (!dap_interest.id) {
      interestErrors.noInterest = "* Interest Field is required";
      isValid = false;
    }
    if (!postcountry) {
      countryErrors.noCountry = "* Country Field is required";
      isValid = false;
    } else if (postcountry.trim().length < 0) {
      countryErrors.shortCountry = "* Country name is too short";
      isValid = false;
    }
    if (!poststate) {
      stateErrors.noState = "* State Field is required";
      isValid = false;
    } else if (poststate.trim().length < 0) {
      stateErrors.shortState = "* State name is too short";
      isValid = false;
    }
    if (!postcity) {
      cityErrors.noCity = "* City Field is required";
      isValid = false;
    } else if (postcity.trim().length < 0) {
      cityErrors.shortCity = "* City name is too short";
      isValid = false;
    }
    if (!dap_probability) {
      probabilityErrors.noProbability = "* Probability Field is required";
      isValid = false;
    }

    if (!dap_address) {
      addressErrors.noAddress = "* Address Field is required";
      isValid = false;
    } else if (dap_address.trim().length < 2) {
      addressErrors.noAddress = "* Address Filed is required";
      isValid = false;
    }
    if (!zip) {
      zipErrors.noZip = "* Zip Field is required";
      isValid = false;
    } else if (/\D/.test(zip)) {
      zipErrors.noZip = "* Only numbers allowed";
    } else if (zip.trim().length != 6) {
      zipErrors.shortZip = "* Zip Should Contain 6 Digit";
      isValid = false;
    }
    if (!dap_phone) {
      phoneErrors.shortNumber = "* Phone number required";
      isValid = false;
    } else if (/\D/.test(dap_phone)) {
      phoneErrors.shortNumber = "* Only numbers allowed";
      isValid = false;
    } else if (dap_phone.trim().length > 10) {
      phoneErrors.shortNumber = "* Phone number should be 10 digits";
      isValid = false;
    } else if (dap_phone.trim().length < 10) {
      phoneErrors.shortNumber = "* Phone number should be 10 digits";
      isValid = false;
    }

    if (dap_billable) {
      if (dap_package.id == undefined) {
        packageError.shortPackage = "* Package is required";
        isValid = false;
      }
    }
    setOrganizationErrors(organizationErrors);
    setDesignationErrors(designationErrors);
    setEmailErrors(emailErrors);
    setNameErrors(nameErrors);
    setLastNameErrors(lastnameErrors);
    setPhoneErrors(phoneErrors);
    setSourceErrors(sourceErrors);
    setIndustryErrors(industryErrors);
    setAwarenessErrors(awarenessErrors);
    setInterestErrors(interestErrors);
    setCountryErrors(countryErrors);
    setstateErrors(stateErrors);
    setCityErrors(cityErrors);
    setZipErrors(zipErrors);
    setAddressErrors(addressErrors);
    setProbabilityErrors(probabilityErrors);
    setPackageError(packageError);
    return isValid;
  };

  const submitHandler = () => {
    console.log(emailErrors);
    const isValid = formValidation();
    console.log(isValid);
    // console.log("Ananyaa");
    // window.location.href = "";
    setLoading(isValid);
    if (isValid == true) {
      // console.log(dap_package.id);
      console.log("hi");
      console.log(dap_name);
      axios
        .post(environment.dap_url + "crm_api/createLead", {
          lead_executive_id: JSON.parse(
            localStorage.getItem("executivedetails")
          )._id,
          parentId: JSON.parse(localStorage.getItem("executivedetails"))
            .createdBy,
          userFirstName: dap_name,
          userLastName: dap_lastname,
          email: dap_email,
          phone: dap_phone,
          organization: dap_organization,
          industry: dap_industry.id,
          awareness: dap_awareness.id,
          designation: dap_designation,
          source: dap_source.id,
          interest: dap_interest.id,
          probability: dap_probability,
          city: postcity,
          state: poststate,
          country: postcountry,
          address: dap_address,
          zip: zip,
          isBillable: dap_billable,
          package: dap_package.id,
        })
        .then((res) => {
          console.log(res);
          setLoading(false);
          if (res.data.message == "already exist") {
            MySwal.fire({
              title: <p>This mail is been Used</p>,
              type: "success",
            });
          } else {
            MySwal.fire({
              title: <p>Lead has been successfully created!</p>,
              type: "success",
            });
            history.push(goBackLink);
          }
        })
        .catch((err) => {
          MySwal.fire({
            title: (
              <p>{err?.response?.data?.message || "Lead creation failed"}</p>
            ),
            type: "error",
          });
        });
    } else {
    }
  };

  const handlechange_new = (e) => {
    const value = e.target.value;
    console.log(value);
    if (value === "yes") {
      setBillable(true);
      setVisible(true);
    }
    if (value === "no") {
      setBillable(false);
      setVisible(false);
      setPackage("");
    }
  };

  // console.log(dap_billable);

  const setprob = (value) => {
    setProbability(value);
    var output = document.getElementById("percent");
    output.innerHTML = value + "%";
  };
  return (
    <div class="container-fluid">
      <NavbarNew />
      <div className="container-fluid">
        <div className="col-12">
          <div className="card-body">
            <div className="row">
              <div className="col-md-6">
                <h4 className="card-title">Add Lead :</h4>
              </div>
              <div className="col-md-6">
                <LinkContainer
                  to={goBackLink}
                  style={{
                    // marginLeft: "80%",
                    // verticalAlign: "bottom",
                    float: "right",
                  }}
                >
                  <Button variant="light" className="btn btn-light">
                    Go Back
                  </Button>
                </LinkContainer>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ marginLeft: "4%", marginRight: "4%" }}>
        <Form>
          <div className="row">
            <div className="col-3">
              <Form.Group controlId="name">
                <Form.Label>*First Name</Form.Label>
                <Form.Control
                  type="title"
                  placeholder="Name"
                  value={dap_name}
                  onChange={(e) => setName(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(nameErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{nameErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="lastname">
                <Form.Label>*Last Name</Form.Label>
                <Form.Control
                  type="title"
                  placeholder="Last Name"
                  value={dap_lastname}
                  onChange={(e) => setLastName(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(lastnameErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{lastnameErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="organization">
                <Form.Label>*Organization</Form.Label>
                <Form.Control
                  type="required"
                  // message="Organization field required"
                  placeholder="Organization"
                  value={dap_organization}
                  onChange={(e) => setOrganization(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(organizationErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>
                        {organizationErrors[key]}
                      </div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="designation">
                <Form.Label>*Designation</Form.Label>
                <Form.Control
                  type="required"
                  // message="Organization field required"
                  placeholder="Designation"
                  value={dap_designation}
                  onChange={(e) => setDesignation(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(designationErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>
                        {designationErrors[key]}
                      </div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>

            <div>
              {/* <div class="dropdown"> */}
              {/* <Form.Group controlId="name">
                <Form.Label> Role</Form.Label>
                <Select
                  options={roles.map((element) => ({
                    id: element.roleType,
                    value: element.roleType,
                    label: element.roleType,
                  }))}
                  // value={dap_role}
                  onChange={(e) => setRole(e)}
                  placeholder="Choose Roles "
                />
              </Form.Group> */}
              {/* </div> */}
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <Form.Group controlId="name">
                <Form.Label>* Email</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Email"
                  value={dap_email}
                  onChange={checkemail}
                ></Form.Control>
                <div>
                  {Object.keys(emailErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{emailErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="role">
                <Form.Label>* Phone</Form.Label>
                <Form.Control
                  type="text"
                  min="0"
                  placeholder="Phone"
                  value={dap_phone}
                  onChange={(e) => setPhone(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(phoneErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{phoneErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="name">
                <Form.Label style={{ marginTop: 35 }}>BILLABLE </Form.Label>
                <input
                  name="billable"
                  id="yes"
                  type="radio"
                  value="yes"
                  // value={true}
                  // value={dap_billable}
                  checked={dap_billable}
                  // onFocus
                  onChange={handlechange_new}
                  style={{ marginTop: 35, marginLeft: 10 }}
                />
                {""}
                Yes
                <span> </span>
                <input
                  name="billable"
                  id="no"
                  type="radio"
                  value="no"
                  // value={false}
                  // value={dap_billable}
                  checked={!dap_billable}
                  onChange={handlechange_new}
                  style={{ marginTop: 24 }}
                />
                {""}
                No
              </Form.Group>
            </div>
            {visible && (
              <div className="col-3">
                <Form.Group controlId="name">
                  <Form.Label> Package</Form.Label>
                  <Select
                    options={roles.map((element) => ({
                      id: element.roleType,
                      value: element.roleType,
                      label: element.roleType,
                    }))}
                    // value={dap_role}
                    onChange={(e) => setPackage(e)}
                    placeholder="Choose Package "
                  />
                  <div>
                    {Object.keys(packageError).map((key) => {
                      return (
                        <div style={{ color: "red" }}>{packageError[key]}</div>
                      );
                    })}
                  </div>
                </Form.Group>
              </div>
            )}
          </div>

          <div className="row">
            <div className="col-3">
              <Form.Group controlId="source">
                <Form.Label>*Source</Form.Label>
                <Select
                  options={roles1.map((element) => ({
                    id: element.roleType,
                    value: element.roleType,
                    label: element.roleType,
                  }))}
                  // value={dap_role}
                  onChange={(e) => setSource(e)}
                  placeholder="Choose Source "
                />
                <div>
                  {Object.keys(sourceErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{sourceErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="industry">
                <Form.Label>*Industry</Form.Label>
                <Select
                  options={roles2.map((element) => ({
                    id: element.roleType,
                    value: element.roleType,
                    label: element.roleType,
                  }))}
                  // onChange={setothers}
                  onChange={(e) => setIndustry(e)}
                  placeholder="Choose Industry "
                />
                <div>
                  {Object.keys(industryErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{industryErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="awareness">
                <Form.Label>*Awareness</Form.Label>
                <Select
                  options={roles3.map((element) => ({
                    id: element.roleType,
                    value: element.roleType,
                    label: element.roleType,
                  }))}
                  // value={dap_role}
                  onChange={(e) => setAwareness(e)}
                  placeholder="Choose Awareness "
                />
                <div>
                  {Object.keys(awarenessErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{awarenessErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="interest">
                <Form.Label> *Interest</Form.Label>
                <Select
                  options={roles4.map((element) => ({
                    id: element.roleType,
                    value: element.roleType,
                    label: element.roleType,
                  }))}
                  // value={dap_role}
                  onChange={(e) => setInterest(e)}
                  placeholder="Choose Interest "
                />
                <div>
                  {Object.keys(interestErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{interestErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <Form.Group controlId="country">
                <Form.Label>*Country</Form.Label>
                <Select
                  options={countries.map((element) => ({
                    id: element.isoCode,
                    value: element.name,
                    label: element.name,
                  }))}
                  onChange={(e) => selectCountry(e)}
                  // defaultValue={dap_deviceList[0].name}
                  defaultValue="hi there"
                  placeholder="Country"
                />
                <div>
                  {Object.keys(countryErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{countryErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="state">
                <Form.Label>*State</Form.Label>
                <Select
                  options={dap_states.map((element) => ({
                    id: element.isoCode,
                    value: element.name,
                    label: element.name,
                  }))}
                  onChange={(e) => selectRegion(e)}
                  // defaultValue={dap_deviceList[0].name}
                  defaultValue="hi there"
                  placeholder="State"
                />
                <div>
                  {Object.keys(stateErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{stateErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="name">
                <Form.Label>*City</Form.Label>
                <Select
                  options={dap_city.map((element) => ({
                    id: element.isoCode,
                    value: element.name,
                    label: element.name,
                  }))}
                  onChange={(e) => selectCity(e)}
                  // defaultValue={dap_deviceList[0].name}
                  defaultValue="hi there"
                  placeholder="City"
                />
                <div>
                  {Object.keys(cityErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{cityErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="zip">
                <Form.Label>*Zip</Form.Label>
                <Form.Control
                  type="text"
                  min="0"
                  placeholder="Enter postal code"
                  value={zip}
                  onChange={(e) => setZip(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(zipErrors).map((key) => {
                    return <div style={{ color: "red" }}>{zipErrors[key]}</div>;
                  })}
                </div>
              </Form.Group>
            </div>
          </div>
          <div className="row">
            <div className="col-9">
              <Form.Group controlId="address">
                <Form.Label> *Address</Form.Label>
                <Form.Control
                  type="address"
                  placeholder="Address"
                  value={dap_address}
                  onChange={(e) => setAddress(e.target.value)}
                ></Form.Control>
                <div>
                  {Object.keys(addressErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>{addressErrors[key]}</div>
                    );
                  })}
                </div>
              </Form.Group>
            </div>
            <div className="col-3">
              <Form.Group controlId="probability">
                <Form.Label> *Probability</Form.Label>
                <div>
                  <label for="customRange1" class="form-label"></label>
                  <input
                    type="range"
                    class="form-range"
                    min="0"
                    max="100"
                    step="1"
                    id="customRange1"
                    onChange={(e) => setprob(e.target.value)}
                  ></input>
                  <label for="percent" id="percent"></label>
                </div>
                <div>
                  {Object.keys(probabilityErrors).map((key) => {
                    return (
                      <div style={{ color: "red" }}>
                        {probabilityErrors[key]}
                      </div>
                    );
                  })}
                </div>
              </Form.Group>
              {/* <div class="progress">
                <div
                  class="progress-bar w-75"
                  role="progressbar"
                  aria-valuenow="75"
                  aria-valuemin="0"
                  aria-valuemax="100"
                  value={dap_address}
                ></div>
                onChange={(e) => setProbability(e.target.value)}
              </div> */}
            </div>
          </div>
        </Form>
      </div>
      <div className="row">
        <div className="col m-3">
          <Link to={goBackLink}>
            <button
              class="btn btn-warning m-1"
              style={{ float: "right", backgroundColor: "red" }}
              onClick={submitHandler}
            >
              CANCEL
            </button>
          </Link>
          <button
            class="btn btn-primary m-1"
            style={{ float: "right" }}
            onClick={submitHandler}
            disabled={loading}
          >
            SAVE
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddLeads;
